var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dv-digital-flop',{key:_vm.key,attrs:{"config":_vm.config}})
}
var staticRenderFns = []

export { render, staticRenderFns }